import { slotObjectToDataTestIds } from '@elliemae/ds-system';

export const DSLeftNavigationName = 'DSLeftnavigation';

// we are naming this with the ${component_name}_region_focuses convention to namespace & avoid errors on duplicate exports variables in aggregators
export const LEFT_NAVIGATION_REGION_FOCUSES = {
  RESET: '',
} as const;

// we are naming this with the ${component_name}_slots convention to namespace & avoid errors on duplicate exports variables in aggregators
export const LEFT_NAVIGATION_SLOTS = {
  ALERTS_ICON_WRAPPER: 'alerts-icon',
  AREAS_CONTAINER: 'areas-container',
  ARROW_CONTAINER: 'arrow-container',
  BODY_AREAS_CONTAINER: 'body-areas-container',
  BODY_HEADER_AREA: 'body-header-area',
  BODY_ITEMS_AREA: 'body-items-area',
  BOTTOM_CONTAINER: 'bottom-container',
  COLLAPSED_CONTAINER: 'collapsed-container',
  EXCEPTIONS_ICON_WRAPPER: 'exceptions-icon',
  FOOTER_ITEM: 'footer-item',
  FOOTER_LABEL: 'footer-label',
  FOOTER_MENU: 'footer-menu',
  FOOTER_MENU_COLLAPSE: 'footer-menu-collapse',
  FOOTER_SEPARATOR: 'footer-separator',
  ITEM: 'item',
  ITEM_BORDER_BOTTOM: 'item-border-bottom',
  ITEM_CHEVRON_BACK: 'item-chevron-back',
  ITEM_DATE: 'item-date',
  ITEM_LABEL: 'item-label',
  ITEM_SEPARATOR: 'item-separator',
  LEFT_CONTAINER: 'left-container',
  LOADER_WRAPPER: 'loader-wrapper',
  HEADER_AREA: 'header-area',
  MESSAGES_ICON_WRAPPER: 'messages-icon',
  NOTIFICATIONS_CONTAINER: 'notifications-container',
  NOTIFICATIONS_ICON: 'notifications-icon',
  RIGHT_CONTAINER: 'right-container',
  ROOT: 'root',
  SECTION_CONTAINER: 'section-container',
  SECTION_LABEL: 'section-label',
  SECTION_RIGHT_LABEL: 'section-right-label',
  VERTICAL_SEPARATOR: 'vertical-separator',
} as const;

// we are naming this with the ${component_name}_data_testid convention to namespace & avoid errors on duplicate exports variables in aggregators
export const LEFT_NAVIGATION_DATA_TESTID = {
  ...slotObjectToDataTestIds(DSLeftNavigationName, LEFT_NAVIGATION_SLOTS),
  /* ********************************************************************************************************************************************
   *    keeping old values around based on vinoth/guncha (forced) request to keep them stable
   *      in the future, before removing/changing those values, please make sure to check with them
   *      (and get written approval for future reference, verba volant, scripta manent).
   * ********************************************************************************************************************************************
   *                  https://jira.elliemae.io/browse/PUI-15589
   ******************************************************************************************************************************************** */
  ROOT: 'leftnav-component',
  HEADER_AREA: 'leftnav-header-area',
  AREAS_CONTAINER: 'ds-leftnavigation-areas-container',

  COLLAPSED_CONTAINER: 'leftnav-leftcomponent',

  BODY_AREAS_CONTAINER: 'ds-leftnavigation-body-areas-container',
  BODY_HEADER_AREA: 'leftnav-body-header-area',
  BODY_ITEMS_AREA: 'leftnav-body-items-area',
  BOTTOM_CONTAINER: 'ds-leftnavigation-bottom-container',

  ITEM: 'leftnav-item-container',
  ITEM_BORDER_BOTTOM: 'ds-leftnavigation-item-border-bottom',
  ITEM_LABEL: 'leftnav-itemlabel',
  ITEM_DATE: 'leftnav-list-item-date',
  ITEM_SEPARATOR: 'leftnav-separator-subitem',
  ITEM_CHEVRON_BACK: 'leftnav-leftcomponent-chevron',

  // repeated with "COLLAPSED_CONTAINER" above, APP QA team doesn't approve us changing this.
  //    IF anyone come with the request to have a separate value for this, address them to guncha/vinoth.
  LEFT_CONTAINER: 'leftnav-leftcomponent',
  RIGHT_CONTAINER: 'leftnav-right-component',
  ARROW_CONTAINER: 'ds-leftnavigation-arrow-container',

  SECTION_CONTAINER: 'ds-leftnavigation-section-container',
  SECTION_LABEL: 'leftnav-section-item-label',
  SECTION_RIGHT_LABEL: 'ds-leftnavigation-section-right-label',

  NOTIFICATIONS_CONTAINER: 'ds-leftnavigation-notifications-container',

  EXCEPTIONS_ICON_WRAPPER: 'left-nav-exceptions-icon',
  ALERTS_ICON_WRAPPER: 'left-nav-alerts-icon',
  MESSAGES_ICON_WRAPPER: 'left-nav-messages-icon',

  FOOTER_MENU: 'leftnav-container',
  FOOTER_SEPARATOR: 'ds-leftnavigation-footer-separator',
  // repeated with "ITEM" above, APP QA team doesn't approve us changing this.
  //    IF anyone come with the request to have a separate value for this, address them to guncha/vinoth.
  FOOTER_ITEM: 'leftnav-item-container',

  VERTICAL_SEPARATOR: 'ds-leftnavigation-vertical-separator',

  // Things that are not slots (why?) and still need data-testids (that needs to not change else APP QA team can't work)
  NOTIFICATION_ICON: 'left-nav-notifications-icon',
  ALERTS_ICON: 'left-nav-alerts-icon',
  EXCEPTIONS_ICON: 'left-nav-exceptions-icon',
  MESSAGES_ICON: 'left-nav-messages-icon',

  // I don't know if there was already a slot or not because the naming convention is confusing and we can't change it.
  //   so I am re-defining those to be sure.
  //  (usually this comes from previous implementation "slot" being a "nested" slot that inherits the slot from the child)
  DROPDOWN_MENU_TRIGGER_WRAPPER: 'dropdown-menu-trigger-wrapper', // used to be dsDropdownmenuRoot slot at time of writing this comment

  NOTIFICATIONS_ICON: 'left-nav-notifications-icon', // used to be dsIconRoot slot at time of writing this comment
  LEFT_COMPONENT_CHEVRON: 'leftnav-leftcomponent-chevron', // used to be dsButtonRoot slot at time of writing this comment
  // VERY SPECIAL CASE, THE SLOT FOOTER_BTN GOES TO THE ICON WHEN COLLAPSED, TO THE BTN WHEN EXPANDED
  //   WE CAN'T FIX THE TECH DEBT
  FOOTER_BTN: 'leftnav-footer-btn', // used to be [ "dsIconRoot", "dsButtonRoot" ] slots at time of writing this comment
  // VERY SPECIAL CASE 2
  //   THE SLOT IS TECHNICALLY dsLeftnavigationItemLabel
  //      which is LEFT_NAVIGATION_SLOTS.ITEM_LABEL
  //   BUT the data-test-id is either "leftnav-itemlabel" or "leftnav-list-item-label"
  //      APPARENTLY (we are not sure) based on it's "type"
  //      "leftnav-list-item-label" for:
  //         - ITEM_TYPES.LEFT_NAV_ITEM_TEXT_LABEL
  //         - ITEM_TYPES.LEFT_NAV_ITEM_WITH_DATE
  //         - ITEM_TYPES.LEFT_NAV_ITEM_UNCONTROLLED_DRILLDOWN
  //         - ITEM_TYPES.LEFT_NAV_ITEM_CONTROLLED_DRILLDOWN
  //   WE CAN'T FIX THE TECH DEBT
  //    IF we somehow need to change this, address them to guncha/vinoth.
  LIST_ITEM_LABEL_ID_EXCEPTION: 'leftnav-list-item-label',
};

export const DSLeftNavigationSlots = LEFT_NAVIGATION_SLOTS;

/* ********************************************************************************************************************************************
 *    Specific left-nav constants. Those are exported to third parties so they can use them in their code.
 ******************************************************************************************************************************************** */

export const LABEL_OVERFLOW = {
  WRAP: 'wrap',
  WRAP_ALL: 'wrapAll',
  TRUNCATE: 'truncate',
};

export const ITEM_TYPES = {
  LEFT_NAV_ITEM_HEADER: 'ds-left-nav-item-header',
  LEFT_NAV_ITEM_LINK: 'ds-left-nav-item-link',
  LEFT_NAV_ITEM_SUBMENU: 'ds-left-nav-item-submenu',
  LEFT_NAV_ITEM_CONTROLLED_DRILLDOWN: 'ds-left-nav-item-controlled-drilldown',
  LEFT_NAV_ITEM_UNCONTROLLED_DRILLDOWN: 'ds-left-nav-item-uncontrolled-drilldown',
  LEFT_NAV_ITEM_SECTION: 'ds-left-nav-item-section',
  LEFT_NAV_ITEM_SEPARATOR: 'ds-left-nav-item-separator',
  LEFT_NAV_ITEM_SKELETON: 'ds-left-nav-item-skeleton',
  LEFT_NAV_ITEM_TEXT_LABEL: 'ds-left-nav-item-text-label',
  LEFT_NAV_ITEM_WITH_DATE: 'ds-left-nav-item-with-date',
};

export const outOfTheBoxTypes = Object.values(ITEM_TYPES);

export const MAP_ITEMS_TO_SKELETON = {
  'ds-left-nav-item-header': 'item',
  'ds-left-nav-item-link': 'subitem',
  'ds-left-nav-item-submenu': 'item',
  'ds-left-nav-item-controlled-drilldown': 'subitem',
  'ds-left-nav-item-uncontrolled-drilldown': 'subitem',
  'ds-left-nav-item-section': 'subitem',
  'ds-left-nav-item-separator': 'subitem',
  'ds-left-nav-item-text-label': 'subitem',
  'ds-left-nav-item-with-date': 'subitem',
} as const;

export const FOOTER_DS_ID = 'ds-left-nav-__internal__-footer';

export const FOOTER_MENU_CLOSE_DS_ID = 'ds-left-nav-__internal__-footer-menu-close';

export const CHEVRON_BACK_DS_ID = 'ds-left-nav-__internal__-chevron-back';
